import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import firebase from "firebase";

import "./assets/tailwind.css";
import "./assets/styles.scss";

const firebaseConfig = {
	apiKey: process.env.VUE_APP_APIKEY,
	authDomain: "stride-auth-vue.firebaseapp.com",
	projectId: "stride-auth-vue",
	storageBucket: "stride-auth-vue.appspot.com",
	messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
	appId: process.env.VUE_APP_APP_ID,
};

firebase.initializeApp(firebaseConfig);

firebase.auth().onAuthStateChanged((user) => {
	if (user) {
		store.dispatch("fetchUser", user);

		user.getIdToken().then((token) => {
			store.dispatch("setToken", token);
		});
	}
});

createApp(App)
	.use(store)
	.use(router)
	.mount("#app");
